module.exports = __webpack_public_path__ + "static/img/pexels-shivkumarsd-1379031.63810f9.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/pexels-shivkumarsd-1379031.webp
// module id = /ulg
// module chunks = 0